import { useMutation, useQueryClient } from "@tanstack/react-query";

import { renameSoilSightProject } from "services";

import { useIsAuthenticated } from "utils";

import { LIST_SOIL_SIGHT_PROJECTS, RENAME_SOIL_SIGHT_PROJECT } from "consts";

export const useRenameSoilSightProject = (klimFarmId: string) => {
  const queryClient = useQueryClient();
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [RENAME_SOIL_SIGHT_PROJECT],
    mutationFn: ({ soilSightProjectId, name }: { soilSightProjectId: string; name: string }) => {
      if (!isAuthenticated) return Promise.reject(new Error("Not Authorized"));
      return renameSoilSightProject(soilSightProjectId, name);
    },
    onSuccess: (_data, _variables) => {
      queryClient.invalidateQueries({ queryKey: [LIST_SOIL_SIGHT_PROJECTS, klimFarmId] });
    },
  });
};
